import TileHolder from './TileHolder';
import { useContext } from 'react';
import {CoursesContext} from '../../context/CoursesContext';
import './tiles.scss';
import { Helmet } from 'react-helmet-async';

function CategoryTileContainer() {

    const { categoryDetails } = useContext(CoursesContext);
    
    const categoriesForPage = categoryDetails.map((category) => ({
        title : category.title,
        content : category.description,
        category: category.category
    }));


    return (
        <>
        <Helmet>
            <title>Watchelm - Categories of Training Courses</title>
            <meta name="description" content="Explore our diverse categories of technical training courses designed to empower your team with the skills they need." />
        </Helmet>
        <div className="categories-page">
            <h1 className="green-to-red-gradient-font categories-page--heading">A Diverse Catalogue of Technical Training Courses, <br/><strong>Rooted in Success</strong></h1>
            <TileHolder tileContents={categoriesForPage} />
        </div>
        </>
        );
        

}
  
  export default CategoryTileContainer;